// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const InterceptionActionSchema = z.enum(['ADD','REMOVE'] as const);

export type InterceptionActionType = `${z.infer<typeof InterceptionActionSchema>}`

export default InterceptionActionSchema;
